<template>
  <div>
    <div class="vx-col w-full mb-base flex">
      <div class="flex-1 px-2">
        <vx-card>
          <vs-list>
            <vs-list-header icon-pack="feather" icon="icon-paperclip" :title="`ข้อมูลนำออกจากระบบ`"></vs-list-header>
            <div v-if="visible">
              <vs-list-item title="สัญญากู้ยืมเงิน">
                <vs-button type="line" line-origin="left" color="success" @click="openUrl(pathLoanAgreement)">เรียกดู
                </vs-button>
              </vs-list-item>
              <vs-list-item title="สัญญาค้ำประกัน">
                <vs-button type="line" line-origin="left" color="success" @click="openUrl(pathSuretyContract)">เรียกดู
                </vs-button>
              </vs-list-item>
              <vs-list-item title="หนังสือให้ความยินยอม">
                <vs-button type="line" line-origin="left" color="success" @click="openUrl(pathPdpaConsentBorrower)">
                  เรียกดู
                </vs-button>
              </vs-list-item>
              <vs-list-item title="หนังสือให้ความยินยอม (ผู้ค้ำประกัน)">
                <vs-button type="line" line-origin="left" color="success" @click="openUrl(pathPdpaConsentSureties)">
                  เรียกดู
                </vs-button>
              </vs-list-item>
            </div>
          </vs-list>
        </vx-card>
      </div>
      <div class="flex-1 px-2">

        <vx-card>
          <vs-list>
            <vs-list-header icon-pack="feather" icon="icon-paperclip" :title="`ข้อมูลนำเข้าระบบ`"></vs-list-header>
          </vs-list>

          <vs-list>
            <vs-list-item v-for="file in filesFilters" :key="file.id" :title="file.description">
              <vs-button type="line" line-origin="left" color="success" @click="download(file)"
                         :disabled="!file.fileName">เรียกดู
              </vs-button>
              <vs-button class="btn-icon" size="medium" color="danger" @click="del(file.id)">ลบ</vs-button>
            </vs-list-item>
            <div class="mt-2">
              <vs-input type="text" class="w-full mt-2 mb-2" v-model="form.description"/>
              <input type="file" @change="onFileChange" ref="inputFile"/>
              <vs-button class="btn-icon" size="medium" color="success" :disabled="!selectedFile || !form.description"
                         @click="onUploadFile">เพิ่ม
              </vs-button>
            </div>
          </vs-list>
        </vx-card>
      </div>
    </div>
    <vs-prompt
      @accept="onUploadFileModal"
      color="warning"
      :is-valid="modal.selectedFile !== null"
      :title="$t('notification.confirm-upload-title')"
      :active.sync="modal.active">
      <div class="con-exemple-prompt">
        {{ $t('notification.confirm-upload-message') }}
        <input class="mt-5 mb-5" type="file" @change="onFileChangeModal" ref="inputFileModal"/>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import {getUploadsUrl} from '@/utils/upload'

import {createNamespacedHelpers} from 'vuex'
import {IFileFrom} from "@/constants/interface";

const {mapActions: mapAccountingActions, mapState: mapAccountingState} = createNamespacedHelpers('Accounting');

export default {
  data() {
    return {
      modal:{
        active: false,
        id: null,
        selectedFile: null,
      },
      selectedFile: null,
      form: {
        description: ""
      },
      reportServer: process.env.VUE_APP_REPORT_SERVER
    };
  },
  async created() {
    const vm = this
    const {getContractFiles} = vm
    await getContractFiles({form: {id: vm.$route.params.id}});
  },
  computed: {
    ...mapAccountingState(['contract', 'files', 'status']),
    visible() {
      try {
        return this.contract.loan.loanType !== 'Restructuring';
      } catch (e) {
        // console.log(e)
        return false;
      }
    },
    pathLoanAgreement() {
      return `${this.reportServer}/pdf/loanAgreement?id=${this.contract.id}&version=v.3.0.0`;
    },
    pathSuretyContract() {
      return `${this.reportServer}/pdf/suretyContract?id=${this.contract.id}&version=v.3.0.0`;
    },
    pathPdpaConsentBorrower() {
      return `${this.reportServer}/pdf/pdpaConsentBorrower?id=${this.contract.id}&version=v.1.0.0`;
    },
    pathPdpaConsentSureties() {
      return `${this.reportServer}/pdf/pdpaConsentSureties?id=${this.contract.id}&version=v.1.0.0`;
    },
    filesFilters() {
      const files = this.files.filter(({fileFrom}) => fileFrom !== IFileFrom.prosecution)
      return files ? files : []
    },
    filesFiltersSmartApp() {
      const fileContracts = this.files.filter(file => file.fileFrom === IFileFrom.contract)
      const fileBorrowers = this.files.filter(file => file.fileFrom === IFileFrom.borrower)
      const fileSureties = this.files.filter(file => file.fileFrom ===IFileFrom.surety)
      return [
        ...fileContracts,
        ...fileBorrowers,
        ...fileSureties
      ]
    }
  },
  methods: {
    ...mapAccountingActions(['getContractFiles', 'uploadFile', 'updateFile', 'createFile', 'deleteFile']),
    download(file) {
      const url = getUploadsUrl(file.fileName)
      window.open(url, '_blank');
    },
    openUrl(url) {
      window.open(url, '_blank');
    },

    async del(id) {
      const vm = this
      const {deleteFile, getContractFiles} = vm
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: vm.$t('notification.confirm-delete-title'),
        text: vm.$t('notification.confirm-delete-message'),
        accept: async () => {
          await deleteFile({
            form: {
              id
            },
            vm
          });
          await getContractFiles({form: {id: vm.$route.params.id}});
        }
      });
    },
    onFileChange(e) {
      this.selectedFile = e.target.files[0];
    },
    async onUploadFile() {
      const vm = this
      const formData = new FormData();
      const {createFile, getContractFiles} = vm
      formData.append("file", vm.selectedFile);  // appending file
      const result = await vm.uploadFile({
        id: vm.$route.params.id,
        form: {
          formData: formData
        },
        vm
      });
      await createFile({
        form: {
          contract: {id: vm.$route.params.id},
          description: vm.form.description,
          fileName: result.fileName,
          fileType: result.fileType,
          pathUrl: result.pathUrl
        },
        vm
      });
      vm.form.description = ""
      vm.selectedFile = null
      vm.$refs.inputFile.value = null
      await getContractFiles({form: {id: vm.$route.params.id}});
    },
    uploadModal(id) {
      const vm = this;
      vm.modal.id = id
      vm.modal.active = true;
    },
    onFileChangeModal(e) {
      this.modal.selectedFile = e.target.files[0];
    },
    async onUploadFileModal() {
      const vm = this
      const formData = new FormData()
      const {updateFile, getContractFiles} = vm
      formData.append("file", this.modal.selectedFile);  // appending file
      const result = await vm.uploadFile ({
        id: vm.$route.params.id,
        form: {
          formData: formData
        },
        vm
      });
      await updateFile({
        id: vm.modal.id,
        form: {
          fileName: result.fileName,
          fileType: result.fileType,
          pathUrl: result.pathUrl
        },
        vm
      });
      await getContractFiles({form: {id: vm.$route.params.id}});
      vm.modal.selectedFile = null;
      vm.modal.active = false;
      vm.$refs.inputFileModal.value = null
    },
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  },
};
</script>

<style>
</style>
